export default () => ({
  isBusy: false,
  items_list: [],
  allCategories: [],
  showPayButton: undefined,
})
